var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.65,81.39v36.25l32.7,36.54c12.59,13.43,8,23.47,5.42,27.16-4.7,6.75-14.84,7.3-18,7.3H74.25c-1.23.05-13.55.36-18.88-7.29-2.56-3.69-7.17-13.73,5.47-27.21l32.22-36V81.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.98,
    y1: 79.51,
    x2: 131.52,
    y2: 79.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.17,66.56a11.33,11.33,0,1,1,11.32-11.33A11.34,11.34,0,0,1,91.17,66.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.28,40.26a8.4,8.4,0,1,1,8.39-8.4A8.41,8.41,0,0,1,115.28,40.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/BEAKER.438d80930a020a8424fba5282452907f.svg";
export { ForwardRef as ReactComponent };